export default __webpack_public_path__ + "static/media/87_mobile.94fcf4af.jpg";